import { createSelector } from 'reselect';

import { getDisableControl } from 'utils/search';

import type { CommonState } from './reducer';

import type { RootState } from 'typesafe-actions';

export const getCommonState = (state: RootState) => state.common;

export const getIsPackagePrice = createSelector(getCommonState, (state: CommonState) => {
  return typeof state.isPackagePrice !== 'object' && state.isPackagePrice;
});

export const getUserIdentifier = createSelector(getCommonState, (state: CommonState) =>
  state.userIdentifier ? state.userIdentifier : undefined,
);

export const getIsDisabledComponent = createSelector(getCommonState, (state: CommonState) => {
  const isDisabled = getDisableControl(state.isDisabledComponent);
  return isDisabled;
});
